// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthTosText_wrapper__xaP0I","a":"AuthTosText_a__cWfkX"};